import React from 'react';
import PropTypes from 'prop-types';
import { currencyFormat } from '../../../utils/formatHelper';

function Price(props) {
  const { min, max } = props;
  const format = (value) => currencyFormat(value, props.currency);

  const title = props.title ? (
    <strong style={{ display: props.inline ? 'inline' : 'block' }}>{props.title}</strong>
  ) : (
    ''
  );
  if (!min && !max) return <span>No available price</span>;

  const price = min == null || max === min ? format(max) : `${format(min)} - ${format(max)}`;
  return (
    <span>
      {title}
      {price}
    </span>
  );
}

Price.propTypes = {
  max: PropTypes.number,
  min: PropTypes.number,
  currency: PropTypes.string.isRequired,
  title: PropTypes.string,
  inline: PropTypes.bool,
};

Price.defaultProps = {
  inline: false,
};

export default Price;
